import { gql } from '../__generated__';

export const GET_RESERVATION_CONFIG = gql(`
  query GetReservationConfig($locationId: String!, $tenantId: String!) {
    getReservationConfig(locationId: $locationId, tenantId: $tenantId) {
      enableLiveUsageEvents
    }
  }
`);
